/* eslint-disable max-len */
import 'react';
const LoadNoDataSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = Date.now();
    return (
        <svg
            version="1.1"
            id={`图层_1_${id}`}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 153 110"
            enableBackground="new 0 0 153 110;"
            xmlSpace="preserve"
            {...props}
        >
            <style type="text/css">
                {
                    `.st0{opacity:0.5;fill-rule:evenodd;clip-rule:evenodd;fill:#558FFF;enable-background:new;}
                    .st1{opacity:0.4088;fill-rule:evenodd;clip-rule:evenodd;fill:#FF5252;enable-background:new;}
                    .st2{opacity:0.21;filter:url(#filter-1-${id});enable-background:new;}
                    .st3{opacity:0.4525;fill:#90AFEC;}
                    .st4{opacity:0.21;filter:url(#filter-2-${id});enable-background:new;}
                    .st5{fill:url(#矩形备份-33_1_${id});stroke:url(#矩形备份-33_2_${id});stroke-width:0.5;}
                    .st6{fill:url(#矩形备份-34_1_${id});stroke:url(#矩形备份-34_2_${id});stroke-width:0.5;}
                    .st7{opacity:0.3183;filter:url(#filter-7-${id});enable-background:new;}
                    .st8{fill:#CADBFF;}
                    .st9{opacity:0.3183;filter:url(#filter-8-${id});enable-background:new;}
                    .st10{opacity:0.3183;filter:url(#filter-9)-${id};enable-background:new;}
                    .st11{fill-rule:evenodd;clip-rule:evenodd;fill:#DBE8FF;}
                    .st12{opacity:0.6275;fill-rule:evenodd;clip-rule:evenodd;fill:#E3E5F2;enable-background:new;}
                    .st13{opacity:0.54;fill:url(#形状结合_2_${id});enable-background:new;}
                    .st14{opacity:0.7;}
                    .st15{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}
                    .st16{fill:url(#形状结合_3_${id});}`
                }
            </style>
            <filter filterUnits="objectBoundingBox" height="100.0%" id={`filter-9-${id}`} width="100.0%" x="0.0%" y="0.0%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="0"></feGaussianBlur>
            </filter>
            <filter filterUnits="objectBoundingBox" height="100.0%" id={`filter-8-${id}`} width="100.0%" x="0.0%" y="0.0%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="0"></feGaussianBlur>
            </filter>
            <filter filterUnits="objectBoundingBox" height="100.0%" id={`filter-7-${id}`} width="100.0%" x="0.0%" y="0.0%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="0"></feGaussianBlur>
            </filter>
            <filter filterUnits="objectBoundingBox" height="132.4%" id={`filter-2-${id}`} width="121.8%" x="-10.9%" y="-16.2%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="4"></feGaussianBlur>
            </filter>
            <filter filterUnits="objectBoundingBox" height="318.2%" id={`filter-1-${id}`} width="146.2%" x="-23.1%" y="-109.1%">
                <feGaussianBlur in="SourceGraphic" stdDeviation="4"></feGaussianBlur>
            </filter>
            <g id={`最终${id}`}>
                <g id={`状态说明${id}`} transform="translate(-163.000000, -2503.000000)">
                    <g id={`编组-26-${id}`} transform="translate(45.000000, 2381.000000)">
                        <g id={`编组${id}`} transform="translate(118.000000, 122.000000)">
                            <circle id={`椭圆形备份-26-${id}`} className="st0" cx="150.5" cy="9.5" r="2.5" />
                            <path
                                id={`形状_5备份-4-${id}`}
                                className="st1"
                                d="M17,95c0-1.2-1.5-2.2-3.8-2.8c-0.7-0.2-1.3-0.7-1.4-1.4C11.2,88.6,10.2,87,9,87
                            s-2.2,1.5-2.8,3.8c-0.2,0.7-0.7,1.3-1.4,1.4C2.6,92.8,1,93.8,1,95s1.5,2.2,3.8,2.8c0.7,0.2,1.3,0.7,1.4,1.4
                            c0.6,2.3,1.6,3.8,2.8,3.8s2.2-1.5,2.8-3.8c0.2-0.7,0.7-1.3,1.4-1.4C15.5,97.1,17,96.2,17,95z"
                            />
                            <g id={`矩形备份-27-${id}`} className="st2">
                                <path
                                    className="st3"
                                    d="M53.5,98h41c3,0,5.5-2.5,5.5-5.5l0,0c0-3-2.5-5.5-5.5-5.5h-41c-3,0-5.5,2.5-5.5,5.5l0,0C48,95.5,50.5,98,53.5,98z"
                                />
                            </g>
                            <g id={`矩形备份-27_1_${id}`} className="st4">
                                <path className="st3" d="M28,12h94c4.4,0,8,3.6,8,8v58c0,4.4-3.6,8-8,8H28c-4.4,0-8-3.6-8-8V20C20,15.6,23.6,12,28,12z" />
                            </g>

                            <linearGradient id={`矩形备份-33_1_${id}`} gradientUnits="userSpaceOnUse" x1="-226.7767" y1="447.0221" x2="-225.7767" y2="446.5334" gradientTransform="matrix(103 0 0 -72 23382 32213)">
                                <stop offset="0" style={{stopColor: '#FFFFFF'}} />
                                <stop offset="0.5688" style={{stopColor: '#FDFFFF'}} />
                                <stop offset="1" style={{stopColor: '#FBFFFF'}} />
                            </linearGradient>

                            <linearGradient id={`矩形备份-33_2_${id}`} gradientUnits="userSpaceOnUse" x1="-226.3208" y1="446.869" x2="-226.0929" y2="446.3983" gradientTransform="matrix(103 0 0 -72 23382 32213)">
                                <stop offset="0" style={{stopColor: '#E4EFFF'}} />
                                <stop offset="1" style={{stopColor: '#FFFFFF'}} />
                            </linearGradient>
                            <path
                                id={`矩形备份-33-${id}`}
                                className="st5"
                                d="M32,9h87c4.4,0,8,3.6,8,8v56c0,4.4-3.6,8-8,8H32c-4.4,0-8-3.6-8-8V17C24,12.6,27.6,9,32,9z"
                            />

                            <linearGradient id={`矩形备份-34_1_${id}`} gradientUnits="userSpaceOnUse" x1="-224.3271" y1="402.9388" x2="-223.3271" y2="402.9184" gradientTransform="matrix(49 0 0 -7 11043 2909)">
                                <stop offset="0" style={{stopColor: '#FFFFFF'}} />
                                <stop offset="0.5688" style={{stopColor: '#FDFFFF'}} />
                                <stop offset="1" style={{stopColor: '#FBFFFF'}} />
                            </linearGradient>

                            <linearGradient id={`矩形备份-34_2_${id}]`} gradientUnits="userSpaceOnUse" x1="-223.5573" y1="402.9054" x2="-223.3294" y2="402.8857" gradientTransform="matrix(49 0 0 -7 11043 2909)">
                                <stop offset="0" style={{stopColor: '#E4EFFF'}} />
                                <stop offset="1" style={{stopColor: '#FFFFFF'}} />
                            </linearGradient>
                            <path
                                id={`矩形备份-34-${id}`}
                                className="st6"
                                d="M54.5,85h42c1.9,0,3.5,1.6,3.5,3.5S98.4,92,96.5,92h-42c-1.9,0-3.5-1.6-3.5-3.5S52.6,85,54.5,85z"
                            />
                            <g id={`矩形备份-31-${id}`} className="st7">
                                <path
                                    className="st8"
                                    d="M83.5,31h27c1.4,0,2.5,1.1,2.5,2.5l0,0c0,1.4-1.1,2.5-2.5,2.5h-27c-1.4,0-2.5-1.1-2.5-2.5l0,0C81,32.1,82.1,31,83.5,31z"
                                />
                            </g>
                            <g id={`矩形备份-35-${id}`} className="st9">
                                <path
                                    className="st8"
                                    d="M83.5,42h27c1.4,0,2.5,1.1,2.5,2.5l0,0c0,1.4-1.1,2.5-2.5,2.5h-27c-1.4,0-2.5-1.1-2.5-2.5l0,0C81,43.1,82.1,42,83.5,42z"
                                />
                            </g>
                            <g id={`矩形备份-36-${id}`} className="st10">
                                <path
                                    className="st8"
                                    d="M83.5,53h12.2c1.4,0,2.5,1.1,2.5,2.5l0,0c0,1.4-1.1,2.5-2.5,2.5H83.5c-1.4,0-2.5-1.1-2.5-2.5l0,0C81,54.1,82.1,53,83.5,53z"
                                />
                            </g>
                            <circle id={`椭圆形备份-19-${id}`} className="st11" cx="47.5" cy="18.5" r="2.5" />
                            <circle id={`椭圆形备份-20-${id}`} className="st1" cx="33.5" cy="18.5" r="2.5" />
                            <circle id={`椭圆形备份-26_1_${id}`} className="st0" cx="40.5" cy="18.5" r="2.5" />
                            <circle id={`椭圆形备份-18-${id}`} className="st12" cx="2.5" cy="2.5" r="2.5" />

                            <linearGradient id={`形状结合_2_${id}`} gradientUnits="userSpaceOnUse" x1="-222.9387" y1="444.2418" x2="-222.658" y2="442.244" gradientTransform="matrix(39.9735 0 0 -41.0221 8956.9648 18230.9609)">
                                <stop offset="0" style={{stopColor: '#44B1FF'}} />
                                <stop offset="1" style={{stopColor: '#3C76FF'}} />
                            </linearGradient>
                            <path
                                id={`形状结合${id}`}
                                className="st13"
                                d="M37.4,34.4c7.3-7.3,19.2-7.2,26.7,0.2c7,7,7.5,17.9,1.5,25.3l5.7,5.8c1,1,1,2.6,0,3.6l0,0c-1,1-2.6,1-3.5,0l0,0l0,0l-5.8-5.9c-7.3,5.1-17.6,4.3-24.2-2.3C30.2,53.6,30.1,41.7,37.4,34.4z M60.5,38.2c-5.4-5.4-14.1-5.5-19.5-0.2s-5.3,14,0.2,19.5s14.1,5.5,19.5,0.2S65.9,43.6,60.5,38.2z"
                            />
                            <g id={`编组-5-${id}`} transform="translate(105.000000, 67.000000)" className="st14">
                                <path
                                    id={`路径${id}`}
                                    className="st15"
                                    d="M14.7,2c-1.6-1.4-3.6-2-6-2C7.7,0,6.5,0.2,5.5,0.5s-2.1,0.9-3,1.7s-1.6,1.6-2,2.6C0.3,5.3,0,7.1,0,7.3c0,0.1,0,0.1,0,0.2l0,0c0.1,1.2,1.2,2.2,2.4,2.2c1.1,0,2.1-0.8,2.4-1.8V7.7c0-0.1,0-0.1,0-0.1c0.4-2.3,1.6-3.3,3.7-3.3c1.1,0,2,0.3,2.6,0.8c0.6,0.5,0.9,1.2,0.9,2.2c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.3-0.7,1-2.3,2.6C7.9,12.8,7,14,6.5,15.1C6.3,15.6,6,16.3,5.9,17c-0.1,0.2-0.1,0.6-0.1,0.6C5.9,19,6.9,20,8.3,20c1.2,0,2.2-0.8,2.4-1.8c0.1-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.1,0-0.1c0.1-0.8,0.2-1.1,0.3-1.3c0.2-0.3,0.7-1,2.4-2.6c1.5-1.3,2.4-2.3,2.8-3.1C16.8,9.7,17,8.7,17,7.5C17.1,5.2,16.3,3.4,14.7,2z"
                                />
                                <path
                                    id={`路径_1_${id}`}
                                    className="st15"
                                    d="M8.5,22C7.1,22,6,23.1,6,24.5c0,0.9,0.5,1.7,1.2,2.2c0.8,0.4,1.7,0.4,2.5,0s1.2-1.3,1.2-2.2C11,23.1,9.9,22,8.5,22z"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
            <linearGradient id={`形状结合_3_${id}`} gradientUnits="userSpaceOnUse" x1="-224.8389" y1="444.879" x2="-223.8389" y2="444.0603" gradientTransform="matrix(54.1738 0 0 -49.0154 12262.8965 21865.9609)">
                <stop offset="0" style={{stopColor: '#EFF5FF'}} />
                <stop offset="1" style={{stopColor: '#DBE4F2'}} />
            </linearGradient>
            <path
                id={`形状结合_1_${id}`}
                className="st16"
                d="M118.1,52.6c1.2,0.7,2.2,1.7,2.9,3l18.4,33c2.2,3.9,0.8,8.7-3.1,10.9
            c-1.2,0.7-2.5,1-3.9,1H94.2c-4.4,0-8-3.6-8-8c0-1.4,0.4-2.9,1.1-4.1l19.7-33C109.4,51.6,114.3,50.4,118.1,52.6z M113.6,89.5
            c-1.4,0-2.5,1.1-2.5,2.5c0,0.9,0.5,1.7,1.2,2.2c0.8,0.4,1.7,0.4,2.5,0c0.8-0.4,1.2-1.3,1.2-2.2C116.2,90.6,115,89.5,113.6,89.5z
            M113.9,67.5c-1.1,0-2.2,0.2-3.3,0.5s-2.1,0.9-3,1.7c-0.9,0.8-1.6,1.6-2,2.6c-0.2,0.5-0.6,2.3-0.6,2.5l0,0V75l0,0.2
            c0.2,1.2,1.2,2,2.4,2c1.1,0,2.1-0.8,2.4-1.8l0,0v-0.2l0-0.2c0.4-2.1,1.6-3.1,3.7-3.1c1.1,0,2,0.3,2.6,0.8c0.6,0.5,0.9,1.2,0.9,2.2
            c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.3-0.7,1-2.3,2.6c-1.5,1.5-2.4,2.7-2.9,3.8c-0.2,0.5-0.4,1.2-0.6,1.9c0,0.1-0.1,0.4-0.1,0.5l0,0l0,0.1
            c0,0,0,0,0,0c0.1,1.3,1.1,2.3,2.5,2.3c1.2,0,2.2-0.8,2.4-1.8c0.1-0.2,0.1-0.3,0.1-0.5l0,0v-0.1l0-0.2c0.1-0.6,0.2-1,0.3-1.1
            c0.2-0.3,0.7-1,2.4-2.6c1.5-1.3,2.4-2.3,2.8-3.1c0.5-0.9,0.7-1.9,0.7-3.1c0.2-2.3-0.7-4.1-2.2-5.5C118.3,68.2,116.3,67.5,113.9,67.5
            z"
            />
        </svg>
    );
};

export default LoadNoDataSvg;
